// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"d0ddcffd","outerContainer":"b0acfc6e","secondaryToolbar":"_9d4b4a07","doorHangerRight":"_9c3a6108","toolbarContainer":"_17908803","toolbarViewerMiddle":"f8524cb4","progressBar":"f5c68d33","back-to-application":"b7b6ea71","root":"bafa7aa6","root--large":"_49f7c065","text":"_2e97bf01","root--colored":"_2d1c832d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Badge/index.styl
// module id = 4922
// module chunks = 39